export const UPDATE_ADVENTURE = 'UPDATE_ADVENTURE'
export const CREATE_ADVENTURE = 'CREATE_ADVENTURE'